import React from 'react';

export default function ContactSection() {
  const locationPinUrl = "https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=Rangs+Naharz,14+Shah+Jalal+Avenue,Sector+4,Uttara,Dhaka-1230,Bangladesh";
  
  const fallbackPinUrl = "https://maps.google.com/maps?q=Rangs%20Naharz,%2014%20Shah%20Jalal%20Avenue,%20Sector%204,%20Uttara,%20Dhaka&t=&z=15&ie=UTF8&iwloc=&output=embed";

  return (
    <section className="py-24 px-6 relative border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="mb-20 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter text-white uppercase mb-6">
            Contact <span className="text-green-500">Us</span>
          </h2>
          <p className="max-w-2xl text-slate-400 text-lg md:text-xl font-light leading-relaxed italic"
             style={{ fontFamily: '"Times New Roman", Times, serif' }}>
            Ready to strengthen your cybersecurity posture? Get in touch with our team 
            today for a consultation or to request more information.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          
          {/* Left Side: Contact Info */}
          <div className="space-y-1">
            <div>
              <h3 className="text-sm font-mono tracking-[0.4em] text-green-500 uppercase mb-1">
                // System_Gateways
              </h3>
              
              <div className="space-y-1 mb-0">
                <div className="flex flex-col">
                  <span className="text-2xs font-mono text-slate-500 uppercase tracking-widest mb-0">General Inquiries</span>
                  <a href="mailto:support@secu-wall.com" className="text-2xl font-bold text-white hover:text-green-500 transition-colors">
                    support@secu-wall.com
                  </a>
                </div>

                <div className="flex flex-col">
                  <span className="text-2xs font-mono text-slate-500 uppercase tracking-widest mb-0">Sales & Demos</span>
                  <a href="mailto:sales@secu-wall.com" className="text-2xl font-bold text-white hover:text-green-500 transition-colors">
                    sales@secu-wall.com
                  </a>
                </div>

                <div className="flex flex-col">
                  <span className="text-2xs font-mono text-slate-500 uppercase tracking-widest mb-0">Phone</span>
                  <a href="tel:+880248954441" className="text-2xl font-bold text-white hover:text-green-500 transition-colors">
                    +88 02 4895 4441-2
                  </a>
                </div>
              </div>

              <div className="space-y-1">
                <div className="flex flex-col">
                  <span className="text-2xs font-mono text-slate-500 uppercase tracking-widest mb-0">Address</span>
                  <address className="text-xl text-slate-300 not-italic font-light mb-1">
                    Rangs Naharz, 14 Shah Jalal Avenue <br />
                    Sector 4, Uttara, Dhaka-1230, Bangladesh
                  </address>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Visual Map Display with PIN */}
          <div className="bg-white/5 p-4 border border-white/10 backdrop-blur-md relative h-[450px]">
            <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-green-500/50" />
            
            <div className="w-full h-full bg-slate-900 border border-white/10 relative overflow-hidden group">
              <iframe 
                title="SecuWall Location"
                src={fallbackPinUrl} 
                className="w-full h-full grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
                allowFullScreen="" 
                loading="lazy" 
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              {/* Decorative Scanline Overlay */}
              <div className="absolute inset-0 pointer-events-none border border-green-500/20" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}